<template>
  <BaseLayout>
    <div class="retrievePasswordTwo">
      <div class="title m-t-120 m-b-60 m-l-75 m-r-75">设置新密码</div>
      <div class>
        <div class="login-input-box">
          <img
            class="registeredInputPasswordImage icon"
            src="./assets/registered-input-password.png"
          />
          <input
            type="password"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'password'}"
            :ref="el => nodes.passwordNode.value = el"
            v-model="form.password"
            placeholder="设置您的登录密码"
            @blur="passwordBlurEvent"
          />
        </div>
        <div class="login-input-box">
          <img
            class="registeredInputPasswordImage icon"
            src="./assets/registered-input-password.png"
          />
          <input
            type="password"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'confirmPassword'}"
            :ref="el => nodes.confirmPasswordNode.value = el"
            v-model="form.confirmPassword"
            placeholder="再次输入密码"
            @blur="confirmPasswordBlurEvent"
          />
        </div>
      </div>
      <div class="login-input-box">
        <div class="submit" @click="submitEvent">确&nbsp;&nbsp;&nbsp;定</div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import { userApi } from '@/apis'
import { toast } from '@/utils/alert'
import { ref, reactive } from 'vue'
import md5 from 'crypto-js/md5'
import router from '@/router'
import { useRoute } from 'vue-router'

export default {
  setup() {
    console.log('process.env', process.env)
    document.getElementsByTagName('title')[0].innerText =
      process.env.VUE_APP_RETRIEVEPASSWORDTWO_TITLE

    const route = useRoute()
    const nodes = {
      passwordNode: ref(null),
      confirmPasswordNode: ref(null),
    }
    console.log('-route.query.registerSource-', route.query)

    const requiredErrorKey = ref('')

    const verify = {
      password: {
        isRequired: true,
        v: () => /^[0-9A-Za-z]{1,8}$/.test(form.password),
        msg: '密码设置字母和数字1-8位',
      },
      confirmPassword: {
        isRequired: true,
        v: () => form.password == form.confirmPassword,
        msg: '两次密码不一致',
      },
    }

    const passwordBlurEvent = () => {
      if (!form.password) {
        return
      }
      if (verify.password.v()) {
        requiredErrorKey.value = ''
      } else {
        requiredErrorKey.value = 'password'
        toast(verify.password.msg)
      }
    }
    const confirmPasswordBlurEvent = () => {
      if (!form.confirmPassword) {
        return
      }
      if (verify.confirmPassword.v()) {
        requiredErrorKey.value = ''
      } else {
        requiredErrorKey.value = 'confirmPassword'
        toast(verify.confirmPassword.msg)
      }
    }

    const form = reactive({
      account: route.query.account, // 账号
      mobile: route.query.mobile, // 手机号码
      mobileVerificationCode: route.query.mobileVerificationCode, // 手机验证码
      password: '',
      confirmPassword: '',
    })

    const remainingTime = ref(null)

    const submitEvent = async () => {
      const verifyKeys = Object.keys(verify)
      const requiredKey = verifyKeys.find((key) => form[key] == '')
      const verifyKey = verifyKeys.find((key) => !verify[key].v())
      if (requiredKey || verifyKey) {
        console.log(verifyKey, requiredKey)
        const key = requiredKey || verifyKey
        requiredErrorKey.value = key
        if (verifyKey == requiredKey) {
          const node = nodes[`${key}Node`]
          node.value.focus()
        } else if (verifyKey != requiredKey) {
          toast(verify[verifyKey].msg)
          const node = nodes[`${key}Node`]
          node.value.focus()
        } else {
          const node = nodes[`${key}Node`]
          node.value.focus()
        }
        return
      }

      console.log(111122)
      const login = await userApi.findPwd({
        account: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/g.test(
          form.account
        )
          ? null
          : form.account,
        email: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/g.test(
          form.account
        )
          ? form.account
          : null,
        md5Pwd: md5(form.password).toString(),
        mobile: form.mobile,
        mobileVerificationCode: form.mobileVerificationCode,
      })
      router.push('/retrievePasswordOneFulfill')
      toast('修改成功')
    }
    return {
      nodes,
      form,
      verify,
      passwordBlurEvent,
      confirmPasswordBlurEvent,
      submitEvent,
      remainingTime,
      requiredErrorKey,
    }
  },
  // components: { ProgressBar },
}
</script>

<style lang="scss">
@import './utils.scss';
.retrievePasswordTwo {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(0deg, #f5f8ff 0%, #ffffff 100%);
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  .title {
    font-size: 36px;
    color: #3f89ff;
  }
  .RegisteredLogoImage {
    width: 75px;
    height: 90px;
    margin-right: 28px;
  }
}
</style>